export class VehicleCalculate {
  vrn: string;
  firstAdmissionDate: Date;
  grossBpm: number;

  date: Date;
  vatId: number;
  bpmPercentage: number;
  exclusive: number;
  bpmAmount: number;
  vatAmount: number;
  inclusive: number;
}
